export const NONE: string = "none";
export const EXISTING: string = "existing";
export const NEW: string = "new";
